import adresseGenerer from '@/services/general/genererAdresse';
import genererContactUtilisateur from '@/services/contact/genererContactUtilisateur';

export default function generer() {
  const adresse = adresseGenerer();
  return {
    tiersId: null,
    nom: '',
    prenom: '',
    fonction: '',
    service: '',
    telephone: '',
    portable: '',
    email: '',
    siteWeb: '',
    archive: false,
    civilite: '',
    adresse: adresse,
    adresseContactDifferente: false,
    accesPortail: false,
    utilisateurId: null,
    utilisateur: genererContactUtilisateur(),
    newsletter: false,
  };
}
